import { constants as config } from '@config';
import detailsTemplate from './redfin-details.hbs';
import redfinSearchResults from './redfin-search-results';
import restrictionFacade from '../../../facade/restrictions/restrictions';
import designFacade from '../../../facade/design/design';
import DesygnerApi from '../../../factory/desygner-api';
import BaseView from '../components/accordion-list/categories-director';

module.exports = BaseView.extend({
  type: 'redfin',
  placeHolderUrl: 'https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg',
  addedThumbnails: [],

  thumbSize: {
    width: 90,
    height: 90
  },

  events: {
    'click .item button': 'openPropertyDetails',
    'click .items-container .header span': 'clickItemsContainerHeader'
  },

  initialize: function (opts) {
    _.bindAll(this, 'clickItemsContainerHeader', 'showPropertyItems');
    this.tool = INKIVE.Tool.getInstance();
    this.companyId = opts.companyId;
    this.searchTerm = opts.searchTerm;
    this.searchTerm
      ? this.search()
      : this.noResults();
  },

  search: function () {
    const url = `brand/companies/${this.companyId}/search?search_key=dealId&search_term=${encodeURIComponent(this.searchTerm)}`;
    this.addedThumbnails = [];

    DesygnerApi.get(url)
      .then((data) => {
        if (!data || !Object.entries(data).length) {
          this.noResults();
          return;
        }

        this.openPropertyDetails(redfinSearchResults.mapResult(data[0]));
      });
  },

  openPropertyDetails: function (item) {
    this.checkCanReplace();
    this.el.querySelector('.tab-content').innerHTML = detailsTemplate({
      item,
      canUseImages: this.canUseImages,
      canUseText: this.canUseText
    });

    this.$el.find('.antiscroll-wrap').antiscroll();

    this.clickItemsContainerHeader();
  },

  checkCanReplace: function () {
    this.canUseImages = restrictionFacade.isFunctionalityAllowed('image_add') ||
      restrictionFacade.isFunctionalityAllowed('image_content') ||
      canUse('image');
    this.canUseText = restrictionFacade.isFunctionalityAllowed('text_add') || canUse('text');

    function canUse (type) {
      let canBeUsed = false;

      designFacade.get().forEach((e) => {
        if (!canBeUsed && e.type === type) {
          const restrictionName = type === 'text'
            ? 'text_change_content'
            : 'image_content';

          canBeUsed = restrictionFacade.isActionAllowed(restrictionName, e.id)
            ? 'onlyReplace'
            : false;
        }
      });

      return canBeUsed;
    }
  },

  clickItemsContainerHeader: function (event) {
    const defaultHeader = this.el.querySelector(this.canUseImages
      ? '.images-header'
      : '.texts-header');
    const target = event
      ? event.currentTarget
      : defaultHeader;

    if (!target || target.classList.contains('active')) {
      return;
    }

    $(target).siblings().removeClass('active');
    target.classList.add('active');

    this.showPropertyItems(target.dataset.key);
  },

  showPropertyItems: function (tab) {
    this.selectedTab = tab;
    const $parent = this.$el.find('.redfin-details').find('.items-content');
    let $container = $parent.find('.' + tab);

    $parent.find('>div').hide();

    if ($container.length) {
      $container.show();
      tab === 'images' && $container.find('.thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);
      this.refreshAntiscroll();
      return;
    }

    $container = $('<div class="' + tab + '"/>').appendTo($parent);

    INKIVE.Modal.loader($container);

    const methodName = 'showProperty' + tab.charAt(0).toUpperCase() + tab.slice(1);
    redfinSearchResults[methodName]($container, this);
  },

  refreshAntiscroll: function () {
    this.$el.find('.antiscroll-wrap').antiscroll({
      horizontal: false,
      height: this.el.offsetHeight
    });
    this.el.querySelector('.antiscroll-scrollbar').style.left = 291;
  },

  noResults: function () {
    document.querySelector('#tabRedfin>.tab-content').innerHTML =
    `<label class="title text-center no-results">${INKIVE.TranslateHelper.translate('common.no_result')}</label>`;
  }
});
